import { type RimmEntityType, type RimmSubEntityType } from '../data/rimmEntityEnums';
import type { RootState } from '../../../store';

export const rimmEntitySelector = (entity: RimmEntityType) => (state: RootState) => state.rimm[entity] ?? { data: [] };

export const rimmSubEntitySelector = (entity: RimmSubEntityType, parentId: string | number) => (state: RootState) =>
  state.rimm[entity][parentId] ?? { data: [] };

export const subEntityHasOptionsSelector =
  (entity: RimmSubEntityType, parentId: string | number) => (state: RootState) =>
    !!state.rimm[entity][parentId]?.data?.length;
